import { Stack, Group, ActionIcon, Text } from '@mantine/core';
import { OrganizationContact } from '@medplum/fhirtypes';
import { IconPlus } from '@tabler/icons-react';
import { useState } from 'react';
import { CreatePartnerContactCard } from './CreatePartnerContactCard';
import { PartnerContactCard } from './PartnerContactCard';

export function PartnerContactsSection({
  contacts,
  onChange,
  onAdd,
  draftContacts = [],
  onDraftContactsChange,
}: {
  contacts: OrganizationContact[];
  onChange: (contacts: OrganizationContact[]) => void;
  onAdd?: (newContact: OrganizationContact) => void;
  draftContacts?: OrganizationContact[];
  onDraftContactsChange?: (contacts: OrganizationContact[]) => void;
}) {
  const [addingNew, setAddingNew] = useState(false);

  return (
    <Stack gap="xs">
      <Group w="100%" justify="space-between">
        <Text style={{ textTransform: 'uppercase' }} c="gray">
          Contacts
        </Text>
        <ActionIcon
          onClick={() => {
            setAddingNew(true);
          }}
          variant="subtle"
          color="gray"
          size={12}
          radius="md"
        >
          <IconPlus />
        </ActionIcon>
      </Group>
      {addingNew && (
        <CreatePartnerContactCard
          onCreate={(newContact) => {
            setAddingNew(false);
            if (onDraftContactsChange) {
              const updatedDrafts = [...draftContacts, newContact];
              onDraftContactsChange(updatedDrafts);
            } else {
              onAdd?.(newContact);
            }
          }}
          onCancel={() => {
            setAddingNew(false);
          }}
        />
      )}
      {/* Render existing persisted contacts */}
      {contacts.map((contact, index) => (
        <PartnerContactCard
          key={`contact-${index}`}
          contact={contact}
          onDelete={() => {
            const updatedContacts = contacts.filter((_, i) => i !== index);
            onChange(updatedContacts);
          }}
          onChange={(updatedContact) => {
            const newContacts = contacts.map((c, i) => (i === index ? updatedContact : c));
            onChange(newContacts);
          }}
        />
      ))}
      {/* Render draft contacts (not yet persisted) */}
      {draftContacts.map((contact, index) => (
        <PartnerContactCard
          key={`draft-${index}`}
          contact={contact}
          onDelete={() => {
            const updatedDrafts = draftContacts.filter((_, i) => i !== index);
            onDraftContactsChange?.(updatedDrafts);
          }}
          onChange={(updatedContact) => {
            const updatedDrafts = draftContacts.map((c, i) => (i === index ? updatedContact : c));
            onDraftContactsChange?.(updatedDrafts);
          }}
        />
      ))}
    </Stack>
  );
}
